import { defineMessages } from 'react-intl';

export default defineMessages({
    saveProgress: {
        id: '_.save_application.save_progress',
        defaultMessage: 'Save progress'
    },
    savingLoading: {
        id: '_.save_application.savingLoading',
        defaultMessage: 'Saving progress'
    },
    saveSuccess: {
        id: '_.save_application.saveSuccess',
        defaultMessage: 'Progress saved'
    },
    errorHeading: {
        id: '_.save_application.errorHeading',
        defaultMessage: `Sorry, an error has occurred`
    },
    errorBody: {
        id: '_.save_application.errorBody',
        defaultMessage: `Unfortunately our servers are not responding at the moment. Please try again in a few minutes.`
    }
});
